import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import TopMenuNavigationDropDown from './TopMenuNavigationDropDown';
import Button from '../../components/button/Button';

const TopMenuItem = ({
    iconClassName,
    linkClassName,
    dropDownItems,
    isDisabled,
    onClick,
    countOfNewItems,
    isDemoModeOn,
    downloadDemoPdf,
    selectedPeriod,
    demoClass,
    isGuidedTourOn,
}) =>
    isEmpty(dropDownItems) ? (
        <li className="nav-item">
            <Button
                className={`nav-item-btn ${linkClassName}`}
                text={<div className={`nav-item-icon ${iconClassName}`} />}
                onClick={onClick}
            />
        </li>
    ) : (
        <TopMenuNavigationDropDown
            title={
                <>
                    <div
                        className={`${iconClassName}`}
                        data-tour-step={`${
                            iconClassName === 'icon-amplify-print' ? 'print-menu-item' : ''
                        }`}
                    />
                    {!!countOfNewItems && (
                        <span className="above-notification-circle">{countOfNewItems}</span>
                    )}
                </>
            }
            items={dropDownItems}
            isDisabled={isDisabled}
            isDemoModeOn={isDemoModeOn}
            downloadDemoPdf={downloadDemoPdf}
            selectedPeriod={selectedPeriod}
            demoClass={demoClass}
            isGuidedTourOn={isGuidedTourOn}
        />
    );

TopMenuItem.defaultProps = {
    iconClassName: '',
    linkClassName: '',
    dropDownItems: [],
    isDisabled: false,
    onClick: () => {},
    countOfNewItems: null,
    isDemoModeOn: false,
    downloadDemoPdf: () => {},
    selectedPeriod: '',
    demoClass: '',
    isGuidedTourOn: false,
};

TopMenuItem.propTypes = {
    iconClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    dropDownItems: PropTypes.array,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    countOfNewItems: PropTypes.any,
    isDemoModeOn: PropTypes.bool,
    downloadDemoPdf: PropTypes.func,
    selectedPeriod: PropTypes.string,
    demoClass: PropTypes.string,
    isGuidedTourOn: PropTypes.bool,
};

export default TopMenuItem;
